import { defineRecipe } from '@chakra-ui/react';

export const separatorRecipe = defineRecipe({
  className: 'chakra-separator',
  base: {
    display: 'block',
    borderColor: 'border',
  },
  variants: {
    variant: {
      solid: {
        borderStyle: 'solid',
      },
      dashed: {
        borderStyle: 'dashed',
      },
      dotted: {
        borderStyle: 'dotted',
      },
    },
    orientation: {
      vertical: {
        borderInlineStartWidth: 'var(--separator-thickness) !important',
        height: '100%',
        margin: '0 !important',
      },
      horizontal: {
        borderTopWidth: 'var(--separator-thickness) !important',
        width: '100%',
        margin: '0 !important',
      },
    },
    size: {
      xs: {
        '--separator-thickness': '0.5px',
      },
      sm: {
        '--separator-thickness': '1px',
      },
      md: {
        '--separator-thickness': '2px',
      },
      lg: {
        '--separator-thickness': '3px',
      },
    },
  },
  defaultVariants: {
    size: 'md',
    variant: 'solid',
    orientation: 'horizontal',
  },
});
